import { render, staticRenderFns } from "./stockMoveHistory.vue?vue&type=template&id=59c63399&scoped=true"
import script from "./stockMoveHistory.vue?vue&type=script&lang=js"
export * from "./stockMoveHistory.vue?vue&type=script&lang=js"
import style0 from "./stockMoveHistory.vue?vue&type=style&index=0&id=59c63399&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c63399",
  null
  
)

export default component.exports